import { _ } from "libs";
import React from "react";
export function Loader({ text, loading = true, notext = false, }) {
    if (!loading) {
        return null;
    }
    return (React.createElement("div", { className: "loading" },
        React.createElement("div", { className: "spinner" }),
        !notext ? React.createElement("div", { className: "label" }, typeof text === "string" ? text : _("loader.defaultText")) : null));
}
export default Loader;
